module.exports = __webpack_public_path__ + "static/media/gallery-wide-4.702b678a.jpg";